// extracted by mini-css-extract-plugin
export default {"menuItem":"AdminLayout_menuItem__lXzKm","layout":"AdminLayout_layout__FsWsF"};